// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Json from "../../../../node_modules/@glennsl/bs-json/src/Json.bs.js";
import * as Curry from "../../../../node_modules/rescript/lib/es6/curry.js";
import * as Belt_Array from "../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as Pervasives from "../../../../node_modules/rescript/lib/es6/pervasives.js";
import * as Json_decode from "../../../../node_modules/@glennsl/bs-json/src/Json_decode.bs.js";
import * as Json_encode from "../../../../node_modules/@glennsl/bs-json/src/Json_encode.bs.js";
import * as Slate$LiteracyplanetClient_libs_hogwash from "./Slate.bs.js";
import * as CustomComponents$LiteracyplanetClient_libs_hogwash from "./CustomComponents.bs.js";

function getBlockComponent(component) {
  if (typeof component !== "number") {
    return CustomComponents$LiteracyplanetClient_libs_hogwash.stringifyBlock(component._0);
  }
  switch (component) {
    case /* Div */0 :
        return "div";
    case /* Paragraph */1 :
        return "paragraph";
    case /* HeadingOne */2 :
        return "heading-one";
    case /* HeadingTwo */3 :
        return "heading-two";
    
  }
}

function getInlineComponent(component) {
  if (typeof component === "number") {
    if (component !== 0) {
      return "span";
    } else {
      return "image";
    }
  } else {
    return CustomComponents$LiteracyplanetClient_libs_hogwash.stringifyInline(component._0);
  }
}

var getMarkComponent = CustomComponents$LiteracyplanetClient_libs_hogwash.stringifyMark;

function blockInlineLeafNode(blockNode) {
  switch (blockNode.TAG | 0) {
    case /* BlockNode */0 :
        return encodeBlock(blockNode._0);
    case /* BlockInlineNode */1 :
        return encodeInlineNode(blockNode._0);
    case /* BlockLeafNode */2 :
        return encodeLeafNode(blockNode._0);
    
  }
}

function encodeBlock(block) {
  return Json_encode.object_({
              hd: [
                "object",
                "block"
              ],
              tl: {
                hd: [
                  "type",
                  getBlockComponent(block.component)
                ],
                tl: {
                  hd: [
                    "data",
                    block.payload
                  ],
                  tl: {
                    hd: [
                      "nodes",
                      Json_encode.array(blockInlineLeafNode, block.nodes)
                    ],
                    tl: /* [] */0
                  }
                }
              }
            });
}

function encodeInlineNode(inline) {
  return Json_encode.object_({
              hd: [
                "object",
                "inline"
              ],
              tl: {
                hd: [
                  "type",
                  getInlineComponent(inline.component)
                ],
                tl: {
                  hd: [
                    "data",
                    inline.payload
                  ],
                  tl: {
                    hd: [
                      "nodes",
                      Json_encode.array(inlineOrLeafNode, inline.nodes)
                    ],
                    tl: /* [] */0
                  }
                }
              }
            });
}

function inlineOrLeafNode(inlineNode) {
  if (inlineNode.TAG === /* InlineNode */0) {
    return encodeInlineNode(inlineNode._0);
  } else {
    return encodeLeafNode(inlineNode._0);
  }
}

function encodeLeafNode(leaf) {
  return Json_encode.object_({
              hd: [
                "object",
                "text"
              ],
              tl: {
                hd: [
                  "data",
                  leaf.payload
                ],
                tl: {
                  hd: [
                    "leaves",
                    Json_encode.array(textOrComponent, leaf.leaves)
                  ],
                  tl: /* [] */0
                }
              }
            });
}

function textOrComponent(leafNode) {
  return encodeTextNode(leafNode._0);
}

function encodeTextNode(text) {
  var marks = text.marks;
  var len = marks.length;
  var text_1 = text.text;
  var text$1 = [
    "text",
    text_1
  ];
  if (len > 0) {
    return Json_encode.object_({
                hd: text$1,
                tl: {
                  hd: [
                    "marks",
                    Json_encode.array(encodeMarkNode, marks)
                  ],
                  tl: /* [] */0
                }
              });
  } else {
    return Json_encode.object_({
                hd: text$1,
                tl: /* [] */0
              });
  }
}

function encodeMarkNode(mark) {
  return Json_encode.object_({
              hd: [
                "type",
                CustomComponents$LiteracyplanetClient_libs_hogwash.stringifyMark(mark.component)
              ],
              tl: {
                hd: [
                  "data",
                  mark.payload
                ],
                tl: /* [] */0
              }
            });
}

function $$document(blockNodes) {
  return Json_encode.object_({
              hd: [
                "document",
                Json_encode.object_({
                      hd: [
                        "nodes",
                        Json_encode.array(blockInlineLeafNode, blockNodes)
                      ],
                      tl: /* [] */0
                    })
              ],
              tl: /* [] */0
            });
}

var Encode = {
  getBlockComponent: getBlockComponent,
  getInlineComponent: getInlineComponent,
  getMarkComponent: getMarkComponent,
  blockInlineLeafNode: blockInlineLeafNode,
  encodeBlock: encodeBlock,
  encodeInlineNode: encodeInlineNode,
  inlineOrLeafNode: inlineOrLeafNode,
  encodeLeafNode: encodeLeafNode,
  textOrComponent: textOrComponent,
  encodeTextNode: encodeTextNode,
  encodeMarkNode: encodeMarkNode,
  $$document: $$document
};

function serializeDocument(blockNodes) {
  return Json.stringify($$document(blockNodes));
}

function serializeBlockNode(blockNode) {
  return Json.stringify(blockInlineLeafNode(blockNode));
}

function serializeBlockNodes(blockNodes) {
  return Json.stringify(Json_encode.array(blockInlineLeafNode, blockNodes));
}

function serializeInlineNode(inlineNode) {
  return Json.stringify(inlineOrLeafNode(inlineNode));
}

function serializeLeafNode(leafNode) {
  return Json.stringify(encodeTextNode(leafNode._0));
}

function serializeAnyNode(anyNode) {
  if (typeof anyNode === "number") {
    throw {
          RE_EXN_ID: "Match_failure",
          _1: [
            "EditorData.re",
            101,
            2
          ],
          Error: new Error()
        };
  }
  switch (anyNode.TAG | 0) {
    case /* IsDocNode */0 :
        throw {
              RE_EXN_ID: "Match_failure",
              _1: [
                "EditorData.re",
                101,
                2
              ],
              Error: new Error()
            };
    case /* IsBlockNode */1 :
        return Json.stringify(blockInlineLeafNode(anyNode._0));
    case /* IsInlineNode */2 :
        return Json.stringify(inlineOrLeafNode(anyNode._0));
    case /* IsLeafNode */3 :
        return Json.stringify(encodeTextNode(anyNode._0._0));
    
  }
}

function map(anyNodeType, fBlock, fInline, fLeaf) {
  var traverseInlineNode = function (inlineNode) {
    if (inlineNode.TAG === /* InlineNode */0) {
      return Belt_Array.reduce(inlineNode._0.nodes, [], (function (acc, node) {
                    var x = Curry._1(fInline, node);
                    var y = Belt_Array.concat([x], acc);
                    return Belt_Array.concat(y, traverseInlineNode(node));
                  }));
    } else {
      return Belt_Array.map(inlineNode._0.leaves, Curry.__1(fLeaf));
    }
  };
  var traverseBlockNode = function (blockNode) {
    switch (blockNode.TAG | 0) {
      case /* BlockNode */0 :
          return Belt_Array.reduce(blockNode._0.nodes, [], (function (acc, node) {
                        var x = Curry._1(fBlock, node);
                        var y = Belt_Array.concat([x], acc);
                        return Belt_Array.concat(y, traverseBlockNode(node));
                      }));
      case /* BlockInlineNode */1 :
          return Belt_Array.reduce(blockNode._0.nodes, [], (function (acc, node) {
                        var x = Curry._1(fInline, node);
                        var y = Belt_Array.concat([x], acc);
                        return Belt_Array.concat(y, traverseInlineNode(node));
                      }));
      case /* BlockLeafNode */2 :
          return Belt_Array.map(blockNode._0.leaves, Curry.__1(fLeaf));
      
    }
  };
  if (typeof anyNodeType === "number") {
    throw {
          RE_EXN_ID: "Match_failure",
          _1: [
            "EditorData.re",
            156,
            2
          ],
          Error: new Error()
        };
  }
  switch (anyNodeType.TAG | 0) {
    case /* IsBlockNode */1 :
        var blockNode = anyNodeType._0;
        var x = Curry._1(fBlock, blockNode);
        return Belt_Array.concat([x], traverseBlockNode(blockNode));
    case /* IsInlineNode */2 :
        var inlineNode = anyNodeType._0;
        var x$1 = Curry._1(fInline, inlineNode);
        return Belt_Array.concat([x$1], traverseInlineNode(inlineNode));
    default:
      throw {
            RE_EXN_ID: "Match_failure",
            _1: [
              "EditorData.re",
              156,
              2
            ],
            Error: new Error()
          };
  }
}

function mapAnyNode(anyNodeType, fBlock, fInline, fLeaf) {
  var traverseInlineNode = function (inlineNode) {
    if (inlineNode.TAG === /* InlineNode */0) {
      var inline = inlineNode._0;
      return {
              TAG: /* InlineNode */0,
              _0: {
                component: inline.component,
                payload: inline.payload,
                nodes: Belt_Array.map(inline.nodes, (function (node) {
                        return traverseInlineNode(Curry._1(fInline, node));
                      }))
              }
            };
    }
    var leaf = inlineNode._0;
    return {
            TAG: /* LeafNode */1,
            _0: {
              component: leaf.component,
              payload: leaf.payload,
              leaves: Belt_Array.map(leaf.leaves, Curry.__1(fLeaf))
            }
          };
  };
  var traverseBlockNode = function (blockNode) {
    switch (blockNode.TAG | 0) {
      case /* BlockNode */0 :
          var block = blockNode._0;
          return {
                  TAG: /* BlockNode */0,
                  _0: {
                    component: block.component,
                    payload: block.payload,
                    nodes: Belt_Array.map(block.nodes, (function (node) {
                            return traverseBlockNode(Curry._1(fBlock, node));
                          }))
                  }
                };
      case /* BlockInlineNode */1 :
          var inline = blockNode._0;
          return {
                  TAG: /* BlockInlineNode */1,
                  _0: {
                    component: inline.component,
                    payload: inline.payload,
                    nodes: Belt_Array.map(inline.nodes, (function (node) {
                            return traverseInlineNode(Curry._1(fInline, node));
                          }))
                  }
                };
      case /* BlockLeafNode */2 :
          var leaf = blockNode._0;
          return {
                  TAG: /* BlockLeafNode */2,
                  _0: {
                    component: leaf.component,
                    payload: leaf.payload,
                    leaves: Belt_Array.map(leaf.leaves, Curry.__1(fLeaf))
                  }
                };
      
    }
  };
  if (typeof anyNodeType === "number") {
    throw {
          RE_EXN_ID: "Match_failure",
          _1: [
            "EditorData.re",
            209,
            2
          ],
          Error: new Error()
        };
  }
  switch (anyNodeType.TAG | 0) {
    case /* IsBlockNode */1 :
        var x = traverseBlockNode(Curry._1(fBlock, anyNodeType._0));
        return {
                TAG: /* IsBlockNode */1,
                _0: x
              };
    case /* IsInlineNode */2 :
        return {
                TAG: /* IsInlineNode */2,
                _0: traverseInlineNode(Curry._1(fInline, anyNodeType._0))
              };
    default:
      throw {
            RE_EXN_ID: "Match_failure",
            _1: [
              "EditorData.re",
              209,
              2
            ],
            Error: new Error()
          };
  }
}

function isNode(json) {
  var val;
  try {
    val = Json_decode.field("object", Json_decode.string, json);
  }
  catch (exn){
    return isDoc(json);
  }
  switch (val) {
    case "block" :
        return {
                TAG: /* IsBlockNode */1,
                _0: block(json)
              };
    case "inline" :
        return {
                TAG: /* IsBlockNode */1,
                _0: blockInline(json)
              };
    case "leaf" :
    case "text" :
        return {
                TAG: /* IsInlineNode */2,
                _0: leaf(json)
              };
    case "value" :
        return {
                TAG: /* IsDocNode */0,
                _0: Json_decode.at({
                        hd: "document",
                        tl: {
                          hd: "nodes",
                          tl: /* [] */0
                        }
                      }, arrayOfAnyNodes)(json)
              };
    default:
      return Pervasives.failwith("Invalid Editor Data - isNode");
  }
}

function isDoc(json) {
  var nodes;
  try {
    nodes = Json_decode.field("document", nodesField, json);
  }
  catch (exn){
    return {
            TAG: /* IsLeafNode */3,
            _0: text(json)
          };
  }
  return {
          TAG: /* IsDocNode */0,
          _0: nodes
        };
}

function nodesField(json) {
  return Json_decode.field("nodes", arrayOfAnyNodes, json);
}

function blockNodes(json) {
  var match = Json_decode.field("object", Json_decode.string, json);
  switch (match) {
    case "block" :
        return block(json);
    case "inline" :
        return blockInline(json);
    case "text" :
        return blockLeaf(json);
    default:
      return Pervasives.failwith("Invalid Editor Data - blockNodes");
  }
}

function inlineNodes(json) {
  var match = Json_decode.field("object", Json_decode.string, json);
  switch (match) {
    case "inline" :
        return inline(json);
    case "leaf" :
    case "text" :
        return leaf(json);
    default:
      return Pervasives.failwith("Invalid Editor Data - inlineNodes");
  }
}

function block(json) {
  var x;
  try {
    x = Json_decode.field("type", Json_decode.string, json);
  }
  catch (exn){
    return Pervasives.failwith("Invalid Editor Data - block");
  }
  switch (x) {
    case "div" :
        return {
                TAG: /* BlockNode */0,
                _0: {
                  component: /* Div */0,
                  payload: Json_encode.object_(/* [] */0),
                  nodes: Json_decode.field("nodes", (function (param) {
                          return Json_decode.array(blockNodes, param);
                        }), json)
                }
              };
    case "heading-one" :
        return {
                TAG: /* BlockNode */0,
                _0: {
                  component: /* HeadingOne */2,
                  payload: CustomComponents$LiteracyplanetClient_libs_hogwash.parseBlockPayload(/* HeadingOne */6, json),
                  nodes: Json_decode.field("nodes", (function (param) {
                          return Json_decode.array(blockNodes, param);
                        }), json)
                }
              };
    case "heading-two" :
        return {
                TAG: /* BlockNode */0,
                _0: {
                  component: /* HeadingTwo */3,
                  payload: CustomComponents$LiteracyplanetClient_libs_hogwash.parseBlockPayload(/* HeadingTwo */7, json),
                  nodes: Json_decode.field("nodes", (function (param) {
                          return Json_decode.array(blockNodes, param);
                        }), json)
                }
              };
    case "paragraph" :
        return {
                TAG: /* BlockNode */0,
                _0: {
                  component: /* Paragraph */1,
                  payload: Json_encode.object_(/* [] */0),
                  nodes: Json_decode.field("nodes", (function (param) {
                          return Json_decode.array(blockNodes, param);
                        }), json)
                }
              };
    default:
      var component = CustomComponents$LiteracyplanetClient_libs_hogwash.parseBlock(x);
      return {
              TAG: /* BlockNode */0,
              _0: {
                component: /* CustomBlock */{
                  _0: component
                },
                payload: CustomComponents$LiteracyplanetClient_libs_hogwash.parseBlockPayload(component, json),
                nodes: Json_decode.field("nodes", (function (param) {
                        return Json_decode.array(blockNodes, param);
                      }), json)
              }
            };
  }
}

function blockInline(json) {
  var x;
  try {
    x = Json_decode.field("type", Json_decode.string, json);
  }
  catch (exn){
    return Pervasives.failwith("Invalid Editor Data - blockInline");
  }
  switch (x) {
    case "image" :
        return {
                TAG: /* BlockInlineNode */1,
                _0: {
                  component: /* Image */0,
                  payload: CustomComponents$LiteracyplanetClient_libs_hogwash.parseInlinePayload(/* Img */0, json),
                  nodes: []
                }
              };
    case "span" :
        return {
                TAG: /* BlockInlineNode */1,
                _0: {
                  component: /* Span */1,
                  payload: Json_encode.object_(/* [] */0),
                  nodes: Json_decode.field("nodes", (function (param) {
                          return Json_decode.array(inlineNodes, param);
                        }), json)
                }
              };
    default:
      var component = CustomComponents$LiteracyplanetClient_libs_hogwash.parseInline(x);
      return {
              TAG: /* BlockInlineNode */1,
              _0: {
                component: /* CustomInline */{
                  _0: component
                },
                payload: CustomComponents$LiteracyplanetClient_libs_hogwash.parseInlinePayload(component, json),
                nodes: Json_decode.field("nodes", (function (param) {
                        return Json_decode.array(inlineNodes, param);
                      }), json)
              }
            };
  }
}

function blockLeaf(json) {
  return {
          TAG: /* BlockLeafNode */2,
          _0: {
            component: /* Span */1,
            payload: Json_encode.object_(/* [] */0),
            leaves: Json_decode.field("leaves", (function (param) {
                    return Json_decode.array(text, param);
                  }), json)
          }
        };
}

function inline(json) {
  var x;
  try {
    x = Json_decode.field("type", Json_decode.string, json);
  }
  catch (exn){
    return Pervasives.failwith("Invalid Editor Data - inline");
  }
  switch (x) {
    case "image" :
        return {
                TAG: /* InlineNode */0,
                _0: {
                  component: /* Image */0,
                  payload: CustomComponents$LiteracyplanetClient_libs_hogwash.parseInlinePayload(/* Img */0, json),
                  nodes: []
                }
              };
    case "span" :
        return {
                TAG: /* InlineNode */0,
                _0: {
                  component: /* Span */1,
                  payload: Json_encode.object_(/* [] */0),
                  nodes: Json_decode.field("nodes", (function (param) {
                          return Json_decode.array(inlineNodes, param);
                        }), json)
                }
              };
    default:
      var component = CustomComponents$LiteracyplanetClient_libs_hogwash.parseInline(x);
      return {
              TAG: /* InlineNode */0,
              _0: {
                component: /* CustomInline */{
                  _0: component
                },
                payload: CustomComponents$LiteracyplanetClient_libs_hogwash.parseInlinePayload(component, json),
                nodes: Json_decode.field("nodes", (function (param) {
                        return Json_decode.array(inlineNodes, param);
                      }), json)
              }
            };
  }
}

function leaf(json) {
  return {
          TAG: /* LeafNode */1,
          _0: {
            component: /* Span */1,
            payload: Json_encode.object_(/* [] */0),
            leaves: Json_decode.field("leaves", (function (param) {
                    return Json_decode.array(text, param);
                  }), json)
          }
        };
}

function text(json) {
  var text$1;
  try {
    text$1 = Json_decode.field("text", Json_decode.string, json);
  }
  catch (exn){
    return Pervasives.failwith("Invalid Editor Data - text");
  }
  var marks = Json_decode.optional((function (param) {
          return Json_decode.field("marks", (function (param) {
                        return Json_decode.array(mark, param);
                      }), param);
        }), json);
  if (marks !== undefined) {
    return /* TextNode */{
            _0: {
              text: text$1,
              marks: marks
            }
          };
  } else {
    return /* TextNode */{
            _0: {
              text: text$1,
              marks: []
            }
          };
  }
}

function mark(json) {
  var x;
  try {
    x = Json_decode.field("type", Json_decode.string, json);
  }
  catch (exn){
    return Pervasives.failwith("Invalid Editor Data - mark");
  }
  var component = CustomComponents$LiteracyplanetClient_libs_hogwash.parseMark(x);
  return {
          component: component,
          payload: CustomComponents$LiteracyplanetClient_libs_hogwash.parseMarkPayload(component, json)
        };
}

function arrayOfAnyNodes(json) {
  return Json_decode.array(isNode, json);
}

var Decode = {
  invalid: "Invalid Editor Data",
  isNode: isNode,
  isDoc: isDoc,
  nodesField: nodesField,
  blockNodes: blockNodes,
  inlineNodes: inlineNodes,
  block: block,
  blockInline: blockInline,
  blockLeaf: blockLeaf,
  inline: inline,
  leaf: leaf,
  text: text,
  mark: mark,
  arrayOfAnyNodes: arrayOfAnyNodes
};

function deserialize(node) {
  return isNode(Json.parseOrRaise(node));
}

function deserializeArrayAnyNode(nodes) {
  return Json_decode.array(isNode, Json.parseOrRaise(nodes));
}

function formatAsBlock(anyNodeType) {
  if (typeof anyNodeType === "number") {
    return Slate$LiteracyplanetClient_libs_hogwash.Make.blockNode([]);
  }
  switch (anyNodeType.TAG | 0) {
    case /* IsDocNode */0 :
        return Slate$LiteracyplanetClient_libs_hogwash.Make.blockNode(Belt_Array.map(anyNodeType._0, formatAsBlock));
    case /* IsBlockNode */1 :
        return anyNodeType._0;
    case /* IsInlineNode */2 :
        return Slate$LiteracyplanetClient_libs_hogwash.Make.blockInlineNode([anyNodeType._0]);
    case /* IsLeafNode */3 :
        return Slate$LiteracyplanetClient_libs_hogwash.Make.blockLeafNode([anyNodeType._0]);
    
  }
}

function formatContentAsBlock(content) {
  return formatAsBlock(isNode(Json.parseOrRaise(content)));
}

export {
  Encode ,
  serializeDocument ,
  serializeBlockNode ,
  serializeBlockNodes ,
  serializeInlineNode ,
  serializeLeafNode ,
  serializeAnyNode ,
  map ,
  mapAnyNode ,
  Decode ,
  deserialize ,
  deserializeArrayAnyNode ,
  formatAsBlock ,
  formatContentAsBlock ,
  
}
/* No side effect */
